import { StructuredText } from "datocms-structured-text-utils"
import React, { useEffect, useMemo, useState } from "react"

import Caption from "../../../design-system/caption"
import ScrollContinuationGradient from "../../../design-system/scroll-continuation-gradient"
import { useHash } from "../../../utils/contexts/page-context"
import BlogTableOfContentsLink from "./blog-table-of-contents-link"
import * as styles from "./index.module.scss"
import { structuredTextToTableOfContentsItems } from "./utils"

interface BlogTableOfContentsProps {
  body: StructuredText
}

const BlogTableOfContents = ({
  body,
}: BlogTableOfContentsProps): React.ReactElement => {
  const tableOfContentsItems = useMemo(
    () => structuredTextToTableOfContentsItems(body),
    [body],
  )

  const [hash] = useHash()
  const [activeItemId, setActiveItemId] = useState<string | null>(null)
  const [isMouseOver, setIsMouseOver] = useState(false)
  useEffect(() => {
    // Prevent the auto-detection of active item when the mouse is over the table of contents
    // We only want to detect the active item when the scrolling is done by the user, not when it's automatic from clicking on a link
    if (!isMouseOver) {
      setActiveItemId(hash ? hash.slice(1) : null)
    }
  }, [isMouseOver, hash])

  return (
    <nav
      aria-label="Table of contents"
      className={styles.container}
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <Caption>Table of contents</Caption>
      <div className={styles.gradientContainer}>
        <ScrollContinuationGradient variant="top" size="30px" hideScrollbar />
        <div className={styles.listWrapper}>
          <ul className={styles.list}>
            {tableOfContentsItems.map(item => (
              <li key={item.id}>
                <BlogTableOfContentsLink
                  activeItemId={activeItemId}
                  item={item}
                  setActiveItemId={setActiveItemId}
                />
              </li>
            ))}
          </ul>
        </div>
        <ScrollContinuationGradient
          variant="bottom"
          size="30px"
          hideScrollbar
        />
      </div>
    </nav>
  )
}
export default BlogTableOfContents
